import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalController, MenuController, IonicRouteStrategy } from '@ionic/angular';

import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

import { UserManagerProvider } from '../providers/user-manager/user-manager';
import { SettingsManagerProvider } from '../providers/settings-manager/settings-manager';
import { StorageManagerProvider } from '../providers/storage-manager/storage-manager';
import { CollectionsManagerProvider } from '../providers/collections-manager/collections-manager';
import { SocketManagerProvider } from '../providers/socket-manager/socket-manager';

import * as Tools from '../bayadic-shared-models/tools/Tools';
import * as Enums from '../bayadic-shared-models/enums/Enums';

import { TranslateService, TranslateStore } from '@ngx-translate/core';

import { Router, RouteReuseStrategy, RouterOutlet, NavigationEnd } from '@angular/router';
import { PAGES } from '../bayadic-shared-models/enums/Enums';
import { TranslationService } from '../providers/translation-service';
import { Storage } from '@ionic/storage-angular';
import { AdsService } from '../providers/ads-manager/ads-service';
import { KeyboardAttachDirective } from '../directives/keyboard-attach/keyboard-attach';
import { AccountManagerProvider } from '../providers/account-manager/account-manager';
import { AjaxBridgeProvider } from '../providers/ajax-bridge/ajax-bridge';
import { AppStateManagerProvider } from '../providers/app-state-manager/app-state-manager';
import { ArchiveManagerProvider } from '../providers/archive-manager/archive-manager';
import { AvatarDatabaseManagerProvider } from '../providers/avatars-manager/avatar-database-manager/avatar-database-manager';
import { AvatarsManagerProvider } from '../providers/avatars-manager/avatars-manager';
import { EventsManagerProvider } from '../providers/events-manager/events-manager';
import { FriendsDatabaseManagerProvider } from '../providers/friends-manager/database/friends-database-manager-provider';
import { FriendsManagerProvider } from '../providers/friends-manager/friends-manager';
import { IconsService } from '../providers/icons-service';
import { ItemsManagerProvider } from '../providers/items-manager/items-manager';
import { LocalNotificationManagerProvider } from '../providers/local-notification-manager/local-notification-manager';
import { MembersDatabaseManagerProvider } from '../providers/members-manager/database/members-database-manager-provider';
import { MembersManagerProvider } from '../providers/members-manager/members-manager';
import { MessagesManagerProvider } from '../providers/messages-manager/messages-manager';
import { NotificationsManagerProvider } from '../providers/notifications-manager/notifications-manager';
import { ProductManagerProvider } from '../providers/product-manager/product-manager';
import { SpaceRepetitionDatabaseManagerProvider } from '../providers/space-repetition-database-manager/space-repetition-database-manager';
import { SpaceRepetitionManagerProvider } from '../providers/space-repetition-manager/space-repetition-manager';
import { DatabaseManagerProvider } from '../providers/storage-manager/database-manager';
import { TimeManagerProvider } from '../providers/time-manager/time-manager';
import { TourGuideManagerProvider } from '../providers/tour-guide-manager/tour-guide-manager';
import { WordsDatabaseService } from '../providers/words-database-service/words-database-service';
import { WordsManagerProvider } from '../providers/words-manager/words-manager';
import { HttpClient } from '@angular/common/http';
import { TelegramWebappService } from '@zakarliuka/ng-telegram-webapp';
import { ChatsManagerProvider } from './modules/core/Providers/chats-manager';
import { ChatsDatabaseService } from '../providers/chats-database-service/chats-database-service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Role } from '../bayadic-shared-models/classes/system/member/roles/Role';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DatabaseManagerProvider,
    AjaxBridgeProvider,
    KeyboardAttachDirective,
    StorageManagerProvider,
    Storage,
    IconsService,
    ChatsManagerProvider,
    ChatsDatabaseService,
    DatabaseManagerProvider,
    ItemsManagerProvider,
    CollectionsManagerProvider,
    MessagesManagerProvider,
    UserManagerProvider,
    MembersManagerProvider,
    FriendsManagerProvider,
    TranslationService,
    SocketManagerProvider,
    EventsManagerProvider,
    SettingsManagerProvider,
    LocalNotificationManagerProvider,
    SpaceRepetitionManagerProvider,
    SpaceRepetitionDatabaseManagerProvider,
    FriendsDatabaseManagerProvider,
    MembersDatabaseManagerProvider,
    AdsService,
    ProductManagerProvider,
    NotificationsManagerProvider,
    TimeManagerProvider,
    AppStateManagerProvider,
    TourGuideManagerProvider,
    WordsManagerProvider,
    WordsDatabaseService,
    ArchiveManagerProvider,
    AccountManagerProvider,
    AvatarsManagerProvider,
    AvatarDatabaseManagerProvider,
    Storage,
    StorageManagerProvider,
    RouterOutlet,
    HttpClient,
    TranslateService,
    TranslateStore,
  ],

})
export class AppComponent implements OnInit, OnDestroy {
  rootPage: any;
  selectedTheme: string;
  modeTitle: string;
  availablePages: PAGES = PAGES;
  _isBayaPlus: Promise<boolean> | boolean = false;
  startRoute: string = "profile/introduction";
  currentUrl: string = '';
  private routerSubscription: any;

  constructor(
    private platform: Platform,
    public userManager: UserManagerProvider,
    public storageManager: StorageManagerProvider,
    private settingsManager: SettingsManagerProvider,
    private router: Router,
    public collectionManager: CollectionsManagerProvider,
    public socketManager: SocketManagerProvider,
    public modalCtrl: ModalController,
    private menu: MenuController,
    private telegramService: TelegramWebappService,
    
    private translateService: TranslateService,
    private translationService: TranslationService
  ) {
    this.initializeApp();

    this.settingsManager.getActiveTheme().subscribe(val => this.selectedTheme = val.toString());
    
    // Subscribe to router events to update current URL
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    this.currentUrl = this.router.url;

    // Add android class to body if platform is Android
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      document.body.classList.add('android');
      //status bar set overlay false
      // make it transparent
      StatusBar.setBackgroundColor({ color: '#00000000' });
      StatusBar.setStyle({  style: Style.Dark });
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.hide();
    }
  }

  private async init() {
    Tools.Dom.addCssClass(this.selectedTheme);
    await this.translationService.useCurrentTranslation();
    await this.translateService.get('BAYADIC').toPromise();
    
    const firstUse = await this.userManager.isFirstUse()
    this.menu.swipeGesture(false);
    let debug = true;
    // if (firstUse || debug) {
    //   await this.checkForLogin();
    // }
    // else {
    //   this.router.navigate(["profile/login"]);
    //   // this.router.navigate(["profile/introduction"]);
    // }
   
    //                    this.collectionManager.changeLanguage(lang);
    const autoNightMode = await this.storageManager.get("autoNightMode")
    if (autoNightMode) {
      if (Tools.Time.getHour() > 22 || Tools.Time.getHour() < 4) {
        this.selectNightTheme();
      }
    }
    this.openCustom();
    this.isBayaPlus();
    this.initModeMenuTitle();
    this.expandTelegram()

  }
  expandTelegram() {
    this.telegramService.expand()
  }

  async initializeApp() {
    await this.platform.ready()
    await this.init();
  }

  getRootNav() {
    return this.rootPage;
  }
  openFirst() {
    this.menu.enable(true, 'first');
    this.menu.open('first');
  }

  openEnd() {
    this.menu.open('end');
  }

  openCustom() {
    this.menu.enable(true, 'custom');
    this.menu.open('custom');
  }
  toggleTheme() {
    Tools.Dom.removeCssClass(this.selectedTheme);
    this.settingsManager.setActiveTheme(Enums.THEMES.getNextTheme(this.selectedTheme));
    Tools.Dom.addCssClass(this.selectedTheme);
  }
  isThemeNightMoode() {
    return this.selectedTheme == Enums.THEMES.dark;
  }
  isBayaPlus() {
    this.settingsManager.getPrimarySettings().then(settings => {
      this._isBayaPlus = settings.isBayaPlus();
    })
  }
  selectNightTheme() {
    Tools.Dom.removeCssClass(this.selectedTheme);
    this.settingsManager.setActiveTheme(Enums.THEMES.dark);
    this.selectedTheme = Enums.THEMES.dark;
    Tools.Dom.addCssClass(this.selectedTheme);
  }
  selectLightTheme() {
    Tools.Dom.removeCssClass(this.selectedTheme);
    this.settingsManager.setActiveTheme(Enums.THEMES.light);
    this.selectedTheme = Enums.THEMES.light;
    Tools.Dom.addCssClass(this.selectedTheme);
  }
  toggleNightMode() {
    Tools.Dom.removeCssClass(this.selectedTheme);
    if (this.isThemeNightMoode()) {
      this.selectedTheme = Enums.THEMES.light;
    }
    else {
      this.selectedTheme = Enums.THEMES.dark;
    }
    if (this.userManager.theme === true) {
      this.userManager.theme = false;
    } else {
      this.userManager.theme = true;
    }
    Tools.Dom.addCssClass(this.selectedTheme);
    this.initModeMenuTitle();
  }
  nightMode() {
    this.toggleNightMode();
  }
  lightMode() {
    this.toggleNightMode();
  }
  isNightMode() {
    return this.isThemeNightMoode();
  }
  isLightMode() {
    return !this.isNightMode();
  }
  initModeMenuTitle() {
    if (this.isThemeNightMoode()) {
      this.translateService.get('MENU.lightMode').subscribe(
        value => {
          // value is our translated string
          this.modeTitle = value;
        }
      )
    }
    else {
      this.translateService.get('MENU.nightMode').subscribe(
        value => {
          this.modeTitle = value;

        }

      )
    }
  }
  getModeMenuTitle() {
    return this.modeTitle;
  }
  async checkForLogin() {
    const loggedIn = await this.userManager.isLoggedIn();
    if (!loggedIn) {
      this.router.navigate([this.startRoute]);
    }
  }
  openPage(pageName: Enums.PAGES) {
    this.router.navigate([pageName]);
    this.menu.close();
  }
  isCreator(): boolean {
    return this.userManager.user?.role === Role.creator;
  }
  ngOnInit() {
    // Component initialization if needed
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  isActive(pageName: string): boolean {
    const url = this.currentUrl || this.router.url;
    // Handle root path redirecting to items
    if (pageName === 'items' && (url === '/' || url === '')) {
      return true;
    }
    // Check if current URL starts with the page name
    // This handles routes like 'items', 'items/123', 'collections', etc.
    return url.startsWith('/' + pageName) || url === '/' + pageName;
  }
}
